<template>
    <div class="task">
        <Head-view :showStyle="4"></Head-view>
        <div class="main">
            <div class="breadcrumb">任务管理</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="fontName">任务名称</div>
                    <div class="searchInp">
                        <el-input
                            v-model="searchVal"
                            prefix-icon="el-icon-search"
                            placeholder="请输入"
                        ></el-input>
                    </div>
                    <div class="departName">路线</div>
                    <div class="searchInp">
                        <el-select
                            v-model="routeId"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in routeArr"
                                :key="item.routeId"
                                :label="item.name"
                                :value="item.routeId"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="departName">巡检员</div>
                    <div class="searchInp">
                        <el-select
                            v-model="staffId"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in soptArr"
                                :key="item.staffId"
                                :label="item.name"
                                :value="item.staffId"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="searchBtn" @click="searchBtn()">搜索</div>
                </div>
                <div class="institutionAddBtn" @click="addrouters()">
                    新建任务
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        v-loading="loading"
                        stripe
                    >
                        <el-table-column
                            prop="province"
                            label="路线图片"
                            width="150"
                        >
                            <template slot-scope="scope">
                                <div class="routeImg">
                                    <img v-if="scope.row.routePicture" :src="scope.row.routePicture" alt="" />
                                    <img v-if="!scope.row.routePicture" src="../../assets/routerDefaultImg.png" alt="" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="任务名称"
                            width="150"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="routeName"
                            label="路线名称"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="taskInspectTime"
                            label="巡检时间"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="staffName"
                            label="巡检员"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="taskStartDate"
                            label="开始时间"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="endTime"
                            label="结束时间"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="frequency"
                            label="巡检周期"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="duration"
                            label="巡检时长"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="180">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="colorBulr"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    class="colorRed"
                                    @click="removeInst(scope.$index, scope.row)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageObj.currentPage"
                        :page-sizes="pageObj.pageSizeArr"
                        :page-size="pageObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getTime } from "../../untils/tools";
export default {
    name: "task",
    data() {
        return {
            searchVal: "",
            routeId: "",
            routeArr: [],
            staffId: "",
            soptArr: [],

            tableData: [],

            insId: "",

            pageObj: {
                currentPage: 1,
                pageSizeArr: [10, 40, 100, 400],
                pageSize: 10,
                total: 0,
            },

            loading: false,

            newPassword: "",
            newPasswords: "",
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))
        this.taskInfo();
        this.rolePersonnelInfo();
        this.getRouteInfo()
    },

    methods: {
        taskInfo(searchFlag = false) {
            this.loading = true
            if (this.searchVal != '' && searchFlag) {
                this.pageObj.currentPage = 1
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                staffId: this.staffId === "" ? -1 : this.staffId,
                routeId: this.routeId == "" ? -1 : this.routeId,
                keyword: this.searchVal,
                page: this.pageObj.currentPage,
                limit: this.pageObj.pageSize,
            };
            this.request
                .post(this.baseUrl + "task/getTaskList", data)
                .then((res) => {
                    if (res.code == 0 && res.data.totalCount >= 0) {
                        let dataArr = [];
                        res.data.list.forEach((item, key) => {
                            dataArr.push(item);
                            dataArr[key]["endTime"] =
                                item.taskStopDate == null
                                    ? "-"
                                    : item.taskStopDate;
                        });
                        this.tableData = dataArr;
                        this.pageObj.total = res.data.totalCount;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.loading = false
                })
                .catch((err) => {
                    this.loading = false
                    console.log(err);
                    this.$message({
                        type: "error",
                        message: "获取点位列表失败",
                    });
                });
        },

        rolePersonnelInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getAllStaffList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.soptArr = res.data;
                        this.soptArr.unshift({
                            name: "无",
                            portrait: "",
                            staffId: 0
                        })
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        getRouteInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "route/getAllRouteList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.routeArr = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        searchBtn() {
            this.taskInfo(true)
        },

        addrouters() {
            this.$router.push("/task/taskAdd");
        },
        handleSizeChange(val) {
            this.pageObj.pageSize = val;
            this.taskInfo()
        },
        handleCurrentChange(val) {
            this.pageObj.currentPage = val;
            this.taskInfo()
        },
        handleEide(index, row) {
            this.$router.push({
                path: "/task/taskAdd",
                query: {
                    id: row.taskId,
                },
            });
        },

        removeInst(index, row) {
            this.$confirm("确定要删除本任务吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        taskId: row.taskId,
                    };
                    this.request
                        .post(this.baseUrl + "task/deleteTask", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                                this.taskInfo()
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "删除失败",
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: "出错，删除失败",
                            });
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.task {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 68px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                display: flex;
                flex-direction: row;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                .fontName {
                    width: 72px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    line-height: 40px;
                }
                .searchInp {
                    width: 211px;
                }
                .departName {
                    width: 64px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: center;
                    line-height: 40px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .institutionAddBtn {
                margin: 14px 17px 0 0;
                float: right;
                width: 95px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;
                .routeImg {
                    width: 78px;
                    height: 78px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
        }

        .colorRed {
            color: rgba(255, 87, 51, 1);
        }

        .colorBulr {
            color: rgba(25, 137, 250, 1);
        }
    }
}
</style>